import { createReducer } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import { fetchTypologies, fetchedTypologies, fetchConflictTypes, fetchedConflictTypes } from './actions';
import { State } from './types';

export const INITIAL_STATE: State = {
  typologies: {
    status: undefined,
    error: undefined,
    data: [],
  },
  conflictTypes: {
    status: undefined,
    error: undefined,
    data: [],
  },
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchTypologies, (state) => {
      state.typologies.status = 'loading';
    })
    .addCase(fetchedTypologies, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.typologies.error = payload as RequestError;
        state.typologies.status = 'error';
      } else {
        state.typologies.data = payload as State['typologies']['data'];
        state.typologies.error = undefined;
        state.typologies.status = 'success';
      }
    })
    .addCase(fetchConflictTypes, (state) => {
      state.conflictTypes.status = 'loading';
    })
    .addCase(fetchedConflictTypes, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.conflictTypes.error = payload as RequestError;
        state.conflictTypes.status = 'error';
      } else {
        state.conflictTypes.data = payload as State['conflictTypes']['data'];
        state.conflictTypes.error = undefined;
        state.conflictTypes.status = 'success';
      }
    })
);
